import { render } from "./product-details.vue?vue&type=template&id=7ce860ce&lang=pug"
import script from "./product-details.vue?vue&type=script&lang=js"
export * from "./product-details.vue?vue&type=script&lang=js"

import "./product-details.vue?vue&type=style&index=0&id=7ce860ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__